import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-close" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["data"]
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 4,
  class: "text-center w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "close-btn close-plan-modal plan-modal bg-dark-grey w-100 ms-auto d-flex justify-content-end align-items-start p-2 cursor-pointer position-absolute top-0 rounded-top",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, _hoisted_2),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.isPdf)
            ? (_openBlock(), _createElementBlock("object", {
                key: 0,
                data: _ctx.documentUrl,
                type: "application/pdf",
                width: "100%",
                height: "1000px",
                id: "smartsearch",
                class: "d-flex flex-column justify-content-center align-items-center mt-20"
              }, [
                _createElementVNode("p", _hoisted_4, [
                  _createTextVNode("Sorry, your browser doesn't support embedded PDFs. "),
                  _createElementVNode("a", {
                    href: _ctx.documentUrl,
                    download: ""
                  }, "Download PDF", 8, _hoisted_5)
                ])
              ], 8, _hoisted_3))
            : (_ctx.isDocx)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "text-center w-100",
                  href: _ctx.documentUrl,
                  download: ""
                }, "Download Word Document", 8, _hoisted_6))
              : (_ctx.isExcel)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "text-center w-100",
                    href: _ctx.documentUrl,
                    download: ""
                  }, "Download Excel Document", 8, _hoisted_7))
                : (_ctx.isImage)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 3,
                      src: _ctx.documentUrl,
                      alt: "Image",
                      width: "100%"
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "Couldn't load the document."))
        ], 64))
  ], 64))
}